









import VueOptions from '@utils/VueOptions'
import VenueMapSelector from '@ui/VenueMapSelector'

settings =
  name: 'VenueForm'

  components: {
    VenueMapSelector,
  }

  vue:
    computed:
      venues: ->
        obj = {}
        for x in [0..12]
          key = Math.floor(Math.random() * 1000)
          obj[key] =
            id: key
            key: key
            title: 'Empire State Building'
            type: null
            in_person: true
            images: []
            address:
              street: '123 Street'
              city: 'New York'
              state: 'New York'
              zip: '123456'
              country: 'United States'
              geo_coordinates:
                lat: 40.6971494
                lng: -73.9972236
        obj

export default VueOptions.vue settings
